module.exports = __webpack_public_path__ + "img/g-class.232e77b1.jpg";